<template>
  <div class="mobile-header-menu-wrapper" :class="{'menu-opened': show_mobile_menu}">

    <div class="mobile-header-wrapper" :class="{'menu-opened': show_mobile_menu}">
      <b-form-checkbox v-if="!show_mobile_menu.show || show_mobile_menu.icons" v-model="color_theme_flag" switch id="color-theme" class="grey-switcher">
        {{ color_theme_name }}
      </b-form-checkbox>

      <div class="mobile-menu-icons-wrapper">
        <svg v-if="!show_mobile_menu" @click="openMenu" width="32" height="26" viewBox="0 0 32 26" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M1 1H31" stroke="#2C3236" stroke-width="2" stroke-linecap="round"/>
          <path d="M1 25H31" stroke="#2C3236" stroke-width="2" stroke-linecap="round"/>
          <path d="M1 13H31" stroke="#2C3236" stroke-width="2" stroke-linecap="round"/>
        </svg>

        <svg v-if="show_mobile_menu" @click="closeMenu" width="25" height="25" viewBox="0 0 25 25" fill="none"
             xmlns="http://www.w3.org/2000/svg">
          <path d="M2 23.2132L23.2132 1.99999" stroke="#2C3236" stroke-width="2" stroke-linecap="round"/>
          <path d="M2 2L23.2132 23.2132" stroke="#2C3236" stroke-width="2" stroke-linecap="round"/>
        </svg>
      </div>
    </div>

    <div class="mobile-menu-wrapper">
      <div v-if="show_mobile_menu" class="mobile-menu-icons">

        <div class="profile-data-wrapper">
          <div class="profile-img-wrapper">
            <div class="profile-img-circle">
              <svg width="34" height="32" viewBox="0 0 34 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M2.41031 23.9499L0.280029 21.5317L12.3516 25.3509C13.3496 26.1569 14.3283 25.9458 16.6314 25.9075C19.5293 25.8691 20.9111 25.4852 21.3333 24.9863L33.1362 21.4358C32.5604 22.357 31.0827 24.3913 30.1615 24.6984C29.2403 25.0054 24.0777 27.0206 19.9899 27.366C17.1822 27.6692 15.8253 27.5387 12.9082 27.3468C10.0102 27.1741 5.53855 25.4469 3.17797 24.4873C2.87091 24.3721 2.62142 24.1802 2.41031 23.9499Z" fill="#CFD0D1"/>
                <path d="M12.4284 25.2933L12.39 25.2741L0.280029 21.5317C0.644671 17.2328 2.02647 9.26823 9.33851 4.14405C10.0294 3.66426 10.2963 3.563 11.4286 3.42866C12.5609 3.29432 14.5586 3.42861 16.7657 3.42861C17.0152 3.42861 17.2839 3.42861 17.5526 3.42861C18.9727 3.40941 20.7 3.06932 22.504 3.49153C25.3444 4.62384 31.5241 9.86317 33.1554 21.455L21.3525 24.9095H21.3333H21.3141C21.2374 24.967 21.1606 25.0246 21.103 25.0822C21.0838 25.1014 21.0646 25.1206 21.0454 25.1398C20.9879 25.1781 20.9495 25.2165 20.8919 25.2741C20.7384 25.4084 20.5465 25.5428 20.2394 25.6771C19.6444 25.9458 18.5889 25.869 16.6314 25.9266C13.8677 26.0034 12.7162 25.5812 12.4284 25.2933Z" fill="#FAFAFA"/>
                <path d="M20.7381 18.8257C19.7017 18.0196 18.2432 17.5015 16.6311 17.5015C16.6311 17.5015 16.6119 17.5015 16.5927 17.5015C14.9614 17.5015 13.5028 18.0196 12.4857 18.8257C11.5261 19.5934 10.9312 20.6105 10.9312 21.7236C10.9312 23.0671 11.3726 24.7175 12.62 25.4852C13.0998 25.7731 13.522 25.9842 14.2321 26.0993C14.9422 26.2145 15.7291 26.0418 16.42 26.0418C16.4775 26.0418 16.5543 26.0418 16.6311 26.0418C16.6887 26.0418 16.7654 26.0418 16.823 26.0418C17.5139 26.0418 18.2816 26.2145 18.9917 26.0993C19.7018 25.9842 20.124 25.7731 20.6038 25.4852C21.8512 24.7175 22.2926 23.0671 22.2926 21.7236C22.2926 20.6105 21.7169 19.5934 20.7381 18.8257Z" fill="#CFD0D1"/>
                <path d="M20.7325 18.8334C20.1952 18.4227 19.5868 18.1099 18.9458 17.9046C18.3029 17.6992 17.6331 17.5879 16.9614 17.5706C15.6218 17.5361 14.263 17.8201 13.1077 18.4957C12.5319 18.8315 12.0138 19.2729 11.6184 19.8141C11.4226 20.0847 11.2634 20.3803 11.1463 20.695C11.0311 21.0098 10.9736 21.3437 10.964 21.6777C10.9525 22.3494 11.0561 23.0268 11.2825 23.6602C11.5071 24.2916 11.8794 24.8807 12.4129 25.2818C12.6797 25.4757 12.981 25.6369 13.2842 25.7693C13.5913 25.8979 13.9156 25.9804 14.2457 26.0303C14.9021 26.1244 15.5719 25.9843 16.2551 25.9574C16.4278 25.9516 16.5967 25.9536 16.7656 25.9516C16.9364 25.9497 17.1091 25.9574 17.28 25.9689C17.6196 25.9919 17.9555 26.0303 18.2875 26.038C18.6215 26.0495 18.9439 26.0207 19.2701 25.944C19.5926 25.873 19.9015 25.7578 20.1952 25.6043C20.4926 25.4488 20.7709 25.2761 21.007 25.0477C21.243 24.8212 21.4407 24.5545 21.6058 24.2685C21.9301 23.6909 22.1067 23.0345 22.193 22.3705C22.2314 22.0385 22.2564 21.7007 22.2257 21.3687C22.1969 21.0366 22.1067 20.7085 21.9762 20.4014C21.7132 19.7796 21.2565 19.2537 20.7325 18.8334ZM20.7441 18.8181C21.2795 19.2326 21.7382 19.7585 22.0261 20.3784C22.17 20.6874 22.2736 21.0175 22.3159 21.3591C22.3581 21.7007 22.3466 22.0423 22.3216 22.3839C22.264 23.0633 22.0932 23.7427 21.7689 24.3568C21.6058 24.662 21.3985 24.946 21.1452 25.1878C20.8937 25.4335 20.5924 25.6196 20.2911 25.7789C19.986 25.942 19.6559 26.0649 19.3181 26.1397C18.9842 26.2203 18.6272 26.2549 18.2856 26.2376C17.9421 26.2261 17.6043 26.1839 17.2704 26.157C16.9403 26.1282 16.6006 26.134 16.2666 26.1359C15.6026 26.157 14.9194 26.2875 14.2266 26.1743C13.8888 26.1167 13.5529 26.0246 13.2401 25.8845C12.9273 25.7405 12.6317 25.5736 12.3534 25.3644C11.8065 24.9364 11.4495 24.3203 11.2231 23.6813C11.0004 23.0364 10.9026 22.3551 10.9006 21.6757C10.9064 20.9906 11.1482 20.317 11.534 19.7527C11.9236 19.1885 12.4417 18.7164 13.029 18.3594C14.2074 17.6474 15.6122 17.3634 16.969 17.4516C17.6504 17.4939 18.324 17.6301 18.9631 17.8585C19.6002 18.083 20.2105 18.3978 20.7441 18.8181Z" fill="#5F6467"/>
                <path d="M7.70907 15.7686L13.2133 16.4442L7.05656 16.425C6.86464 16.425 6.69191 16.4826 6.55757 16.5977L0.281891 21.53L0.608149 18.824C1.22228 18.9391 2.52732 18.4593 3.00711 17.0967C3.75559 14.9856 5.42526 13.8917 6.28889 13.5654L7.70907 15.7686Z" fill="#2C3236"/>
                <path d="M20.1433 10.3047L27.8008 11.9936L25.3635 15.5056L20.1817 16.2541H20.1625H20.1433L18.5945 17.0832L17.8979 14.4309L20.1433 10.3047Z" fill="#FAFAFA"/>
                <path fill-rule="evenodd" clip-rule="evenodd" d="M20.0935 10.1953L27.9612 11.9305L25.4185 15.5945L20.1886 16.3499H20.1674L18.5326 17.2251L17.7143 14.2857L20.0935 10.1953ZM20.1931 10.4138L17.9193 14.3106L18.6565 16.9411L20.1193 16.158H20.1748L25.3084 15.4165L27.6404 12.0563L20.1931 10.4138Z" fill="#3F4448"/>
                <path d="M13.1959 10.2854L5.55762 12.2813L7.76466 15.6783L13.1959 16.35H13.2151H13.2343L14.6737 17.0601L15.403 14.4308L13.1959 10.2854Z" fill="#FAFAFA"/>
                <path fill-rule="evenodd" clip-rule="evenodd" d="M13.245 10.1733L15.634 14.263L14.7352 17.1973L13.212 16.4459H13.19L7.70859 15.768L5.40475 12.2221L13.245 10.1733ZM5.71058 12.3405L7.82083 15.5885L13.2019 16.254H13.2567L14.6122 16.9227L15.4285 14.2855L13.1469 10.3973L5.71058 12.3405Z" fill="#3F4448"/>
                <path d="M16.7271 23.9116V23.0864C16.7271 23.0288 16.6888 22.9712 16.6312 22.952C16.5736 22.9712 16.5352 23.0288 16.5352 23.0864V23.9116C16.5352 23.95 16.516 23.9884 16.4968 24.0267C16.4585 24.0843 16.4009 24.1227 16.3241 24.1227H15.9019C15.7868 24.1227 15.6524 24.0843 15.5565 24.0076C15.5181 23.9692 15.4797 23.9308 15.4413 23.8732L15.2302 23.451C15.1918 23.3742 15.1726 23.2783 15.1918 23.2015C15.211 23.1247 15.2494 23.048 15.2878 22.9904L15.5565 22.6066C15.6332 22.5106 15.6716 22.3955 15.6716 22.2611V21.8965C15.6716 21.7621 15.5948 21.647 15.4605 21.5894C15.307 21.5318 15.1342 21.5894 15.0575 21.7429L14.8847 22.0884C14.8272 22.1843 14.7312 22.2611 14.6161 22.2611C14.4433 22.2611 14.3282 22.1268 14.3282 21.954V21.2631C14.3282 21.0904 14.405 20.9177 14.5393 20.8025L15.4989 20.0157C15.5948 19.9389 15.7292 19.8813 15.8635 19.8813H17.3797C17.514 19.8813 17.6292 19.9197 17.7443 20.0157L18.7039 20.8025C18.8382 20.9177 18.915 21.0904 18.915 21.2631V21.954C18.915 22.1268 18.7807 22.2611 18.6271 22.2611C18.512 22.2611 18.416 22.2035 18.3584 22.0884L18.1857 21.7429C18.1089 21.5894 17.9362 21.5126 17.7827 21.5894C17.6675 21.647 17.5716 21.7621 17.5716 21.8965V22.2611C17.5716 22.3763 17.61 22.5106 17.6867 22.6066L17.9554 22.9904C17.9938 23.048 18.0322 23.1247 18.0514 23.2015C18.0706 23.2975 18.0514 23.3742 18.013 23.451L17.8019 23.8732C17.7827 23.9308 17.7443 23.9692 17.6867 24.0076C17.5908 24.0843 17.4756 24.1227 17.3413 24.1227H16.9191C16.8423 24.1227 16.7847 24.0843 16.7463 24.0267C16.7463 23.9884 16.7271 23.95 16.7271 23.9116Z" fill="#3F4448"/>
                <path d="M16.5544 25.3125C15.9921 25.3854 15.4298 25.4007 14.8636 25.3739C14.7235 25.3624 14.5738 25.3528 14.428 25.3067C14.2859 25.2606 14.1497 25.1954 14.0307 25.109C13.7889 24.9421 13.6066 24.7118 13.4645 24.468C13.6661 24.6676 13.8772 24.8499 14.1113 24.9824C14.3474 25.1186 14.5968 25.1743 14.8751 25.182L15.7119 25.2299C15.9921 25.2472 16.2742 25.2741 16.5544 25.3125Z" fill="#5F6467"/>
                <path d="M30.6987 0.133016C31.2553 0.190591 31.6583 0.363316 31.8886 0.574425C34.1724 6.73495 32.0613 11.149 30.7563 12.7228C29.9119 10.7268 28.4149 8.63493 26.8604 6.90768C26.0735 6.02486 25.2483 5.238 24.519 4.62387C23.8473 4.06731 23.1372 3.74105 22.6574 3.49156C24.9028 1.68754 27.0331 0.651191 28.626 0.286549C29.4513 0.0946325 30.1422 0.0562491 30.6987 0.133016Z" fill="#2C3236"/>
                <path fill-rule="evenodd" clip-rule="evenodd" d="M30.6855 0.228086C30.1434 0.153314 29.4647 0.190024 28.6477 0.380025L28.6474 0.3801C27.0995 0.734424 25.0279 1.73341 22.8331 3.47402C22.859 3.48718 22.8853 3.50058 22.9122 3.51424C23.3758 3.74979 23.9929 4.06337 24.5802 4.54999L24.5807 4.55048C25.3133 5.1674 26.1418 5.95735 26.9317 6.84361C28.4524 8.53323 29.9213 10.5741 30.7814 12.5385C32.0698 10.8908 34.007 6.58865 31.8068 0.630063C31.5935 0.443816 31.2185 0.283273 30.6888 0.228477L30.6872 0.228309L30.6855 0.228086ZM30.7101 0.0377466C30.1395 -0.0407121 29.437 -0.000558078 28.6044 0.193059C26.9936 0.561832 24.8505 1.60649 22.5972 3.41677L22.4826 3.50887L22.6131 3.57671C22.6806 3.61184 22.7524 3.64832 22.8276 3.68657C23.2915 3.92246 23.888 4.2258 24.4574 4.69753C25.1833 5.3088 26.0051 6.09238 26.7887 6.97154L26.789 6.97189C28.3394 8.6946 29.829 10.7775 30.6679 12.7602L30.7293 12.9055L30.8301 12.784C32.1546 11.1868 34.2755 6.73711 31.9785 0.541081L31.9705 0.519356L31.9534 0.5037C31.7032 0.274329 31.2785 0.0967937 30.7101 0.0377466Z" fill="#CFD0D1"/>
                <path d="M26.7836 13.452L25.3634 15.5055L20.1625 16.254L20.6998 14.0277L24.4422 12.4348L26.7836 13.452Z" fill="white"/>
                <path fill-rule="evenodd" clip-rule="evenodd" d="M24.4426 12.3303L26.9289 13.4105L25.4185 15.5945L20.0359 16.3691L20.6179 13.9583L24.4426 12.3303ZM20.7818 14.0971L20.289 16.1388L25.3083 15.4164L26.6382 13.4934L24.4418 12.5392L20.7818 14.0971Z" fill="#3F4448"/>
                <path d="M8.7051 12.4158L6.3829 13.5481L7.76471 15.6784L13.2151 16.3501L12.4667 14.0087L8.7051 12.4158Z" fill="white"/>
                <path fill-rule="evenodd" clip-rule="evenodd" d="M8.70221 12.3103L12.5446 13.9374L13.3521 16.4636L7.70847 15.768L6.24332 13.5093L8.70221 12.3103ZM8.70781 12.5211L6.52232 13.5867L7.82077 15.5885L13.078 16.2364L12.3886 14.0798L8.70781 12.5211Z" fill="#3F4448"/>
                <path d="M25.419 15.5938L20.1663 16.3499L26.227 16.3691C26.4189 16.3691 26.5916 16.4267 26.7452 16.5419L33.136 21.4357L32.6754 18.8449C32.1956 19.0368 30.6987 18.0772 30.334 17.0217C29.5664 14.7187 27.7048 13.7975 26.8411 13.4712L25.419 15.5938Z" fill="#2C3236"/>
                <path d="M29.2977 0.11378C30.1997 -0.0397531 31.0442 -0.00136968 31.6583 0.478423C30.2765 0.766298 27.2539 2.09134 25.1428 5.14282C24.7974 4.85495 24.1927 4.31676 23.6362 4.00969C23.3291 3.83697 23.0604 3.68343 22.8493 3.58748C22.7726 3.54909 22.6958 3.51071 22.6574 3.49152C22.6958 3.45313 22.7534 3.41475 22.8301 3.35718C23.0221 3.22283 23.2907 3.03092 23.617 2.80062C24.2887 2.34002 25.2099 1.76427 26.2079 1.24609C27.225 0.708723 28.2998 0.267314 29.2977 0.11378Z" fill="#CFD0D1"/>
                <path d="M2.31419 12.8956C3.17782 10.8997 4.92426 8.13611 6.74747 6.33209C7.68787 5.41089 8.49392 4.71999 9.20401 4.2402C9.58785 3.99071 9.60704 3.93313 10.0484 3.74121C10.1252 3.70283 10.2787 3.64526 10.3555 3.60687C10.2979 3.58768 10.2212 3.53011 10.1252 3.49172C9.89491 3.39576 9.54946 3.24223 9.14644 3.05031C8.34039 2.70486 7.24646 2.24426 6.13334 1.80285C5.02022 1.38064 3.86872 0.97761 2.92833 0.74731C2.46772 0.63216 2.04551 0.555393 1.71925 0.536201C1.56571 0.536201 1.41218 0.536201 1.31622 0.555393C1.22026 0.574585 1.1435 0.51701 1.08592 0.536201C-1.19789 6.71593 1.00915 11.3411 2.31419 12.8956Z" fill="#2C3236"/>
                <path fill-rule="evenodd" clip-rule="evenodd" d="M1.21001 0.452472C1.24778 0.461915 1.27241 0.466076 1.29746 0.461066C1.40284 0.439991 1.56352 0.440001 1.70997 0.440011L1.72212 0.440011L1.72494 0.440177C2.05966 0.459866 2.48832 0.538161 2.95143 0.653929C3.89781 0.885715 5.0538 1.29049 6.16742 1.7129L6.16877 1.71341C7.28301 2.15526 8.37781 2.61625 9.18429 2.96188L9.18603 2.96263L9.18774 2.96344C9.5893 3.15466 9.93301 3.30741 10.1616 3.40266C10.2158 3.42442 10.2638 3.45121 10.3018 3.47263C10.3439 3.49627 10.368 3.50962 10.3859 3.51561L10.6057 3.58886L10.3985 3.69247C10.3571 3.71315 10.2972 3.73811 10.2417 3.76123L10.2389 3.76239C10.18 3.78693 10.1261 3.80945 10.0914 3.82681L10.0891 3.82796L10.0868 3.82898C9.77729 3.96353 9.68619 4.02681 9.51497 4.14574C9.44753 4.19258 9.36765 4.24806 9.2571 4.31994C8.55402 4.79509 7.7529 5.48134 6.81479 6.40029C5.00167 8.19442 3.2618 10.9471 2.40231 12.9335L2.34063 13.0761L2.24075 12.9571C0.916227 11.3794 -1.30116 6.71846 0.995969 0.502705L1.01194 0.459501L1.05563 0.444935C1.08988 0.433521 1.12222 0.435132 1.14633 0.438577C1.16646 0.441452 1.18754 0.446789 1.20348 0.450825C1.20577 0.451405 1.20795 0.451957 1.21001 0.452472ZM1.15158 0.635681C-1.02263 6.59248 0.999801 11.0777 2.28956 12.713C3.1773 10.7205 4.89041 8.03443 6.68003 6.26365L6.68038 6.26331C7.62269 5.34022 8.43343 4.64485 9.15034 4.16045L9.15176 4.1595C9.25472 4.09257 9.33185 4.03903 9.39884 3.99251C9.57589 3.86956 9.68221 3.79573 10.008 3.65397C10.0415 3.63734 10.0866 3.61805 10.1316 3.59923C10.1179 3.59258 10.1039 3.58631 10.0896 3.58058L10.0883 3.58007C9.85662 3.48352 9.51035 3.3296 9.10695 3.13754C8.30165 2.79242 7.20965 2.33265 6.09868 1.89209C4.98637 1.47019 3.83973 1.06906 2.90555 0.840282L2.90511 0.840171C2.44844 0.726005 2.03384 0.650894 1.71646 0.631928C1.55946 0.631934 1.41889 0.632498 1.3351 0.649256C1.26419 0.663438 1.20246 0.648408 1.16346 0.638659C1.16095 0.63803 1.15856 0.637433 1.1563 0.636865C1.15467 0.636455 1.1531 0.636061 1.15158 0.635681Z" fill="#CFD0D1"/>
                <path d="M10.5283 3.58751C9.49198 3.06933 5.69202 0.536028 3.50417 0.248153C2.54458 0.0946193 1.43146 0.0754276 1.00925 0.516836C1.68096 0.67037 2.87084 1.15016 4.07992 1.86025C5.40415 2.64711 6.68999 3.64508 7.78391 5.23799C8.09098 4.95012 10.0869 3.91377 10.5283 3.58751Z" fill="#CFD0D1"/>
                <path d="M23.828 12.7996L21.7169 13.7016C21.7169 14.6036 22.2927 15.6783 23.6361 15.1985C25.0755 14.6803 24.4038 13.241 23.828 12.7996Z" fill="#CFD0D1"/>
                <path d="M23.3482 14.7187C23.7722 14.7187 24.1159 14.375 24.1159 13.951C24.1159 13.527 23.7722 13.1833 23.3482 13.1833C22.9243 13.1833 22.5806 13.527 22.5806 13.951C22.5806 14.375 22.9243 14.7187 23.3482 14.7187Z" fill="#2C3236"/>
                <path d="M9.47276 12.8572L11.5263 13.7208C11.5263 14.6228 10.9697 15.7743 9.6263 15.2945C8.18692 14.7763 8.89701 13.2986 9.47276 12.8572Z" fill="#CFD0D1"/>
                <path d="M10.2979 15.0065C10.7219 15.0065 11.0656 14.6628 11.0656 14.2389C11.0656 13.8149 10.7219 13.4712 10.2979 13.4712C9.87394 13.4712 9.53024 13.8149 9.53024 14.2389C9.53024 14.6628 9.87394 15.0065 10.2979 15.0065Z" fill="#2C3236"/>
                <path d="M18.5503 17.2137H14.712L15.4796 14.335H17.7826L18.5503 17.2137Z" fill="#3F4448"/>
                <path d="M15.9595 18.9409V19.9005H17.3029V18.9409H15.9595Z" fill="#2C3236"/>
                <path d="M18.5504 17.2136L17.3029 18.9409V19.9005L18.5504 18.0772V17.2136Z" fill="#2C3236"/>
                <path d="M14.712 17.2136L15.9594 18.9409V19.9005L14.712 18.0772V17.2136Z" fill="#2C3236"/>
                <path d="M15.9594 18.9409L14.712 17.2136H18.5503L17.3029 18.9409H15.9594Z" fill="#5F6467"/>
                <path d="M22.7917 26.9246C18.1473 27.9609 12.5625 27.366 10.8929 27.0589L7.89896 31.9912C7.89896 31.9912 13.221 31.9912 16.6312 31.9912C20.2662 31.9912 25.9391 31.9912 25.9391 31.9912L22.7917 26.9246Z" fill="#5F6467"/>
                <path d="M28.8945 14.757C28.2996 14.162 27.34 13.663 26.841 13.4903L27.8198 12.1277L27.9541 11.955L27.6663 11.8782L20.0855 10.1893L17.8209 3.42875C20.1431 3.35198 22.0431 3.3379 22.734 3.52982C29.6814 7.23382 31.9844 15.2368 32.6753 18.8448C32.5985 18.864 32.4834 18.8832 32.2531 18.8256C32.0228 18.7488 31.7157 18.5953 31.4662 18.4034C30.948 18.0004 30.5258 17.5781 30.2955 16.8297C30.1996 16.5034 30.0076 16.158 29.7773 15.7741C29.5278 15.4095 29.24 15.064 28.8945 14.757Z" fill="#CFD0D1"/>
                <path d="M3.27382 11.0531C1.54656 14.0086 0.817279 17.0601 0.606171 18.8449C1.64252 18.8833 2.65968 18.3076 3.13947 16.7338C3.25462 16.3692 4.04148 15.1409 4.67481 14.5844C5.26975 14.0854 5.82631 13.7399 6.26772 13.5864L5.48086 12.3965L5.36571 12.243L5.55763 12.1854L13.1767 10.2087L16 3.42864C13.4091 3.42864 11.3919 3.29967 10.701 3.49159C7.28488 5.10369 4.88592 8.05921 3.27382 11.0531Z" fill="#CFD0D1"/>
                <path d="M15.4799 14.335L13.1429 10.1896L15.4416 3.05028C15.4991 2.83918 15.6911 2.70483 15.9022 2.70483H17.3607C17.5718 2.70483 17.7638 2.83918 17.8213 3.05028L20.1917 10.1896L17.783 14.335H15.4799Z" fill="#3F4448"/>
              </svg>
            </div>
          </div>

          <div class="select-profile-data-wrapper" @click="additional_menu_popup.show = true">
          <span class="menu-text-item" v-if="$store.getters.getUserData">
            {{ $store.getters.getUserData.email }}
          </span>
            <svg class="select-profile-data-icon" width="10" height="6" viewBox="0 0 10 6" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M5 6L0.669873 -8.15666e-07L9.33013 -5.85621e-08L5 6Z" fill="#2C3236"/>
            </svg>
          </div>
        </div>

        <div class="menu-items-wrapper">
          <div :class="currentPageMenuClass('Desktop')" @click="goToPage('Desktop')">
            <div class="icon-wrapper">
              <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect class="svg-fill-hover" width="8.38095" height="7.61905" rx="1" fill="#2C3236"/>
                <rect class="svg-fill-hover" y="9.14279" width="8.38095" height="6.85714" rx="1" fill="#2C3236"/>
                <rect class="svg-fill-hover" x="9.65076" y="7.61905" width="6.09524" height="8.38095" rx="1" fill="#2C3236"/>
                <rect class="svg-stroke-hover" x="10.1508" y="0.5" width="5.09524" height="5.09524" rx="0.5" stroke="#2C3236"/>
              </svg>
            </div>

            <div class="menu-item-title">
              {{ $t('routes.desktop') }}
            </div>
          </div>

          <div :class="currentPageMenuClass('leads')" @click="goToPage('leads')">
            <div class="icon-wrapper">
              <svg width="18" height="16" viewBox="0 0 18 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path class="svg-stroke-hover" d="M15.2312 1.43052L15.2311 1.43043C14.6146 0.814082 13.8567 0.5 12.9852 0.5C12.1137 0.5 11.3557 0.81406 10.7393 1.43048L10.7393 1.4305C10.1229 2.04702 9.80872 2.80491 9.80872 3.67645C9.80872 4.47947 10.0754 5.186 10.5994 5.77427H10.4304C9.34794 5.77427 8.47046 6.65175 8.47046 7.73418V8.53208C8.47046 8.89941 8.57369 9.25934 8.76837 9.57083L9.19237 9.30584L8.76837 9.57084L9.79043 11.2061C10.1486 11.7792 10.7767 12.1273 11.4524 12.1273H14.4174C15.0687 12.1273 15.6775 11.8037 16.0419 11.2639L17.1645 9.60069C17.3832 9.2768 17.5 8.89494 17.5 8.50417V7.73418C17.5 6.65175 16.6225 5.77427 15.5401 5.77427H15.3711C15.8951 5.186 16.1617 4.47949 16.1617 3.67645C16.1617 2.80493 15.8476 2.04702 15.2312 1.43052Z" stroke="#2C3236"/>
                <path class="svg-stroke-hover svg-fill-hover" d="M7.26074 1.43052L7.26065 1.43043C6.64413 0.814082 5.88624 0.5 5.01475 0.5C4.14329 0.5 3.38526 0.81406 2.76885 1.43048L2.76884 1.4305C2.1524 2.04702 1.83826 2.80491 1.83826 3.67645C1.83826 4.47947 2.10489 5.186 2.62896 5.77427H2.45991C1.37748 5.77427 0.5 6.65175 0.5 7.73418V8.53208C0.5 8.89941 0.603228 9.25934 0.79791 9.57083L1.22191 9.30584L0.79791 9.57084L1.81997 11.2061C2.17812 11.7792 2.80621 12.1273 3.48197 12.1273H6.44694C7.09825 12.1273 7.70702 11.8037 8.07141 11.2639L9.19409 9.60069C9.41272 9.2768 9.52953 8.89494 9.52953 8.50417V7.73418C9.52953 6.65175 8.65205 5.77427 7.56962 5.77427H7.4006C7.92462 5.186 8.19128 4.47949 8.19128 3.67645C8.19128 2.80493 7.87711 2.04702 7.26074 1.43052Z" fill="#2C3236" stroke="#2C3236"/>
                <path class="svg-fill-hover black-theme-stroke-dark"
                      d="M11.246 4.08734L11.2459 4.08725C10.6294 3.4709 9.87147 3.15682 8.99998 3.15682C8.12852 3.15682 7.37049 3.47088 6.75408 4.08731L6.75407 4.08732C6.13763 4.70384 5.82349 5.46174 5.82349 6.33327C5.82349 7.13629 6.09012 7.84282 6.61419 8.43109H6.44514C5.36271 8.43109 4.48523 9.30858 4.48523 10.391V11.1889C4.48523 11.5562 4.58846 11.9162 4.78314 12.2277L5.20714 11.9627L4.78314 12.2277L5.8052 13.863C6.16335 14.436 6.79144 14.7841 7.4672 14.7841H10.4322C11.0835 14.7841 11.6922 14.4606 12.0566 13.9207L13.1793 12.2575C13.3979 11.9336 13.5148 11.5518 13.5148 11.161V10.391C13.5148 9.30858 12.6373 8.43109 11.5549 8.43109H11.3858C11.9098 7.84283 12.1765 7.13631 12.1765 6.33327C12.1765 5.46175 11.8623 4.70384 11.246 4.08734Z" fill="#2C3236" :stroke="color_theme_flag ? '#2C3236' : '#FAFAFA'"/>
              </svg>
            </div>

            <div class="menu-item-title">
              {{ $t('routes.leads') }}
            </div>
          </div>

          <div :class="currentPageMenuClass('instruments')" @click="goToPage('instruments')">
            <div class="icon-wrapper">
              <svg width="14" height="20" viewBox="0 0 14 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path class="svg-fill-hover" fill-rule="evenodd" clip-rule="evenodd" d="M11.1222 4.28436C11.1221 4.23158 11.1078 4.17968 11.0807 4.1344L10.6155 3.3594C10.5581 3.26367 10.5422 3.14863 10.5716 3.0409L10.971 1.57622C11.0195 1.39803 11.1814 1.27441 11.3661 1.27441L11.9455 1.27443C12.1303 1.27443 12.2921 1.39808 12.3407 1.57629L12.7396 3.04012C12.7689 3.1477 12.7531 3.26257 12.6958 3.35823L12.2311 4.13411C12.2039 4.17955 12.1894 4.23148 12.1894 4.28436L12.1894 9.54308C12.823 9.76943 13.2764 10.3749 13.2764 11.0862L13.2764 17.6389C13.2764 18.5437 12.5429 19.2771 11.6382 19.2771C10.7334 19.2771 10 18.5437 10 17.6389L10 11.0862C10 10.3618 10.4702 9.74716 11.1221 9.53096L11.1222 4.28436ZM11.064 10.9109C11.2902 10.9147 11.4705 11.1011 11.4666 11.3272L11.4481 17.3098C11.4443 17.5359 11.2579 17.7162 11.0318 17.7124C10.8056 17.7085 10.6254 17.5221 10.6292 17.296L10.6477 11.3135C10.6515 11.0873 10.8379 10.9071 11.064 10.9109Z" fill="#2C3236"/>
                <path class="svg-fill-hover" fill-rule="evenodd" clip-rule="evenodd" d="M0.959625 5.36652C-0.319875 4.08702 -0.319875 2.01254 0.959625 0.733036C1.28851 0.404156 1.66991 0.159812 2.07683 0V2.13131C2.07683 2.58368 2.44355 2.9504 2.89592 2.9504L3.71502 2.9504C4.16739 2.9504 4.53411 2.58368 4.53411 2.13131V0.0235103C4.91919 0.183377 5.27996 0.419886 5.59311 0.733036C6.87261 2.01254 6.87261 4.08702 5.59311 5.36652C5.42776 5.53187 5.24913 5.67585 5.06066 5.79846C4.92343 5.88774 4.83222 6.03619 4.83222 6.19991V13.8001C4.83222 13.9638 4.92343 14.1123 5.06066 14.2015C5.24913 14.3242 5.42776 14.4681 5.59311 14.6335C6.87261 15.913 6.87261 17.9875 5.59311 19.267C5.26423 19.5958 4.88282 19.8402 4.4759 20V17.8687C4.4759 17.4163 4.10918 17.0496 3.65681 17.0496H2.83772C2.38535 17.0496 2.01863 17.4163 2.01863 17.8687L2.01863 19.9765C1.63355 19.8166 1.27278 19.5801 0.959625 19.267C-0.319875 17.9875 -0.319875 15.913 0.959625 14.6335C1.08277 14.5103 1.21328 14.399 1.34974 14.2996C1.47453 14.2087 1.55585 14.0671 1.55585 13.9127L1.55585 6.08731C1.55585 5.9329 1.47453 5.79134 1.34974 5.7004C1.21328 5.60096 1.08277 5.48966 0.959625 5.36652Z" fill="#2C3236"/>
              </svg>
            </div>

            <div class="menu-item-title">
              {{ $t('routes.instruments') }}
            </div>
          </div>

          <div :class="currentPageMenuClass('reports')" @click="goToPage('reports')" v-show="$store.getters.getUserData && $store.getters.getUserData.permissions && $store.getters.getUserData.permissions.includes('reports')">
            <div class="icon-wrapper">
              <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path class="svg-fill-hover" fill-rule="evenodd" clip-rule="evenodd" d="M1.33333 0C0.596924 0 0 0.596944 0 1.33333V14.6667C0 15.403 0.596924 16 1.33333 16H9.33333H10.6667H13.3333C14.8061 16 15.3333 14.8061 15.3333 13.3333V6C15.3333 5.63182 15.0348 5.33333 14.6667 5.33333H12V1.33333C12 0.596944 11.4031 0 10.6667 0H1.33333ZM14.6667 6H12V14C12 14.7364 12.5969 15.3333 13.3333 15.3333C14.0697 15.3333 14.6667 14.7364 14.6667 14V6ZM2.33333 6.83333C2.33333 6.55719 2.48257 6.33333 2.66667 6.33333H8C8.1841 6.33333 8.33333 6.55719 8.33333 6.83333C8.33333 7.10948 8.1841 7.33333 8 7.33333H2.66667C2.48257 7.33333 2.33333 7.10948 2.33333 6.83333ZM2.73333 3.66667C2.51242 3.66667 2.33333 3.89052 2.33333 4.16667C2.33333 4.44281 2.51242 4.66667 2.73333 4.66667H5.93333C6.15425 4.66667 6.33333 4.44281 6.33333 4.16667C6.33333 3.89052 6.15425 3.66667 5.93333 3.66667H2.73333ZM2.33333 9.5C2.33333 9.22386 2.53232 9 2.77778 9H9.88889C10.1343 9 10.3333 9.22386 10.3333 9.5C10.3333 9.77614 10.1343 10 9.88889 10H2.77778C2.53232 10 2.33333 9.77614 2.33333 9.5ZM2.73333 11.6667C2.51242 11.6667 2.33333 11.8905 2.33333 12.1667C2.33333 12.4428 2.51242 12.6667 2.73333 12.6667H5.93333C6.15425 12.6667 6.33333 12.4428 6.33333 12.1667C6.33333 11.8905 6.15425 11.6667 5.93333 11.6667H2.73333Z" fill="#2C3236"/>
              </svg>
            </div>

            <div class="menu-item-title">
              {{ $t('routes.reports') }}
            </div>
          </div>

          <div :class="currentPageMenuClass('analytics')" @click="goToPage('analytics')">
            <div class="icon-wrapper">
              <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path class="svg-fill-hover" fill-rule="evenodd" clip-rule="evenodd" d="M7.52533 2.13495L7.92912 4.75634C7.97569 5.0588 8.10826 5.31331 8.2925 5.51301C6.0077 6.04642 4.30604 8.09398 4.30604 10.5385C4.30604 13.3887 6.61949 15.6993 9.4733 15.6993C11.9085 15.6993 13.9502 14.0169 14.4968 11.7524C14.7067 11.9585 14.979 12.1089 15.3067 12.1635L17.8625 12.5889C18.169 12.6399 18.4794 12.5926 18.75 12.4651C17.859 16.7667 14.0443 20 9.4733 20C4.24134 20 0 15.7639 0 10.5385C0 5.93224 3.29571 2.0948 7.66047 1.25C7.52943 1.51871 7.47807 1.82825 7.52533 2.13495Z" fill="#2C3236"/>
                <path class="svg-stroke-hover" d="M9.67552 3.62376L9.25463 0.91511L9.54739 0.517345C9.7386 0.505842 9.93136 0.5 10.1256 0.5C15.3076 0.5 19.5 4.65794 19.5 9.77656C19.5 10.0078 19.4915 10.2371 19.4747 10.464L19.4744 10.4676C19.4744 10.468 19.4744 10.4684 19.4743 10.4688C19.4599 10.6282 19.2954 10.7829 19.0621 10.7445L16.3981 10.3048C16.1986 10.2719 16.0116 10.0657 16.0116 9.77656C16.0116 6.55059 13.3717 3.94389 10.1256 3.94389C9.8669 3.94389 9.69944 3.77761 9.67552 3.62378C9.67552 3.62377 9.67552 3.62377 9.67552 3.62376ZM9.25463 0.915102C9.22043 0.695016 9.37161 0.527924 9.54739 0.517345L9.25463 0.915102Z" stroke="#2C3236"/>
              </svg>
            </div>

            <div class="menu-item-title">
              {{ $t('routes.analytics') }}
            </div>
          </div>

          <div :class="currentPageMenuClass('library')" @click="goToPage('library')">
            <div class="icon-wrapper">
              <svg width="21" height="19" viewBox="0 0 21 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path class="svg-fill-hover svg-stroke-hover" d="M0.5 9V8C0.5 7.72386 0.723858 7.5 1 7.5H3.5C3.77614 7.5 4 7.72386 4 8C4 8.82843 4.67157 9.5 5.5 9.5H13C13.2761 9.5 13.5 9.72386 13.5 10V18C13.5 18.2761 13.2761 18.5 13 18.5H1C0.723858 18.5 0.5 18.2761 0.5 18V9Z" fill="#2C3236" stroke="#2C3236"/>
                <path class="svg-fill-hover" d="M3 3.5C2.72386 3.5 2.5 3.72386 2.5 4C2.5 4.27614 2.72386 4.5 3 4.5V3.5ZM16.5 17.5C16.5 17.7761 16.7239 18 17 18C17.2761 18 17.5 17.7761 17.5 17.5H16.5ZM3 4.5H6V3.5H3V4.5ZM8 6.5H16V5.5H8V6.5ZM16.5 7V17.5H17.5V7H16.5ZM16 6.5C16.2761 6.5 16.5 6.72386 16.5 7H17.5C17.5 6.17157 16.8284 5.5 16 5.5V6.5ZM6.5 5C6.5 5.82843 7.17157 6.5 8 6.5V5.5C7.72386 5.5 7.5 5.27614 7.5 5H6.5ZM6 4.5C6.27614 4.5 6.5 4.72386 6.5 5H7.5C7.5 4.17157 6.82843 3.5 6 3.5V4.5Z" fill="#2C3236"/>
                <path class="svg-fill-hover" d="M6 0.5C5.72386 0.5 5.5 0.723858 5.5 1C5.5 1.27614 5.72386 1.5 6 1.5V0.5ZM19.5 16.5C19.5 16.7761 19.7239 17 20 17C20.2761 17 20.5 16.7761 20.5 16.5H19.5ZM6 1.5H9V0.5H6V1.5ZM11 3.5H19V2.5H11V3.5ZM19.5 4V16.5H20.5V4H19.5ZM19 3.5C19.2761 3.5 19.5 3.72386 19.5 4H20.5C20.5 3.17157 19.8284 2.5 19 2.5V3.5ZM9.5 2C9.5 2.82843 10.1716 3.5 11 3.5V2.5C10.7239 2.5 10.5 2.27614 10.5 2H9.5ZM9 1.5C9.27614 1.5 9.5 1.72386 9.5 2H10.5C10.5 1.17157 9.82843 0.5 9 0.5V1.5Z" fill="#2C3236"/>
              </svg>
            </div>

            <div class="menu-item-title">
              {{ $t('routes.library') }}
            </div>
          </div>
        </div>

        <div class="language-wrapper" v-if="$store.getters.getLanguage">
          <div class="language" @click="languages_popup.show = true">
            {{ $store.getters.getLanguage.toUpperCase() }}
          </div>
        </div>

      </div>
    </div>

    <div v-if="show_mobile_menu" class='mobile-menu-footer icons-footer'>
      <svg width="30" height="32" viewBox="0 0 30 32" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M27.5388 3.03335L20.9447 9.6275C20.7761 9.79613 20.6813 10.0248 20.6813 10.2633V31.099C20.6813 31.9001 21.6499 32.3013 22.2164 31.7348L28.8104 25.1408C28.9791 24.9722 29.0738 24.7435 29.0738 24.505V3.66917C29.0738 2.86807 28.1052 2.46688 27.5388 3.03335Z" fill="#FF4402"/>
        <path fill-rule="evenodd" clip-rule="evenodd" d="M0.299792 8.39274C0.134255 8.39274 6.10352e-05 8.25855 6.10352e-05 8.09301V7.6177C6.10352e-05 7.53821 0.0316398 7.46197 0.0878503 7.40576C0.276671 7.21694 0.599524 7.35067 0.599524 7.6177V8.09301C0.599524 8.25855 0.46533 8.39274 0.299792 8.39274Z" fill="#FF4402"/>
        <path fill-rule="evenodd" clip-rule="evenodd" d="M2.69805 8.39234C2.53251 8.39234 2.39832 8.25814 2.39832 8.09261V5.21945C2.39832 5.13995 2.42989 5.06371 2.4861 5.0075C2.67493 4.81868 2.99778 4.95241 2.99778 5.21945V8.09261C2.99778 8.25814 2.86358 8.39234 2.69805 8.39234Z" fill="#FF4402"/>
        <path fill-rule="evenodd" clip-rule="evenodd" d="M5.09527 8.39297C4.92973 8.39297 4.79553 8.25878 4.79553 8.09324V2.82223C4.79553 2.74273 4.82711 2.6665 4.88332 2.61029C5.07214 2.42147 5.395 2.5552 5.395 2.82223V8.09324C5.395 8.25878 5.2608 8.39297 5.09527 8.39297Z" fill="#FF4402"/>
        <path fill-rule="evenodd" clip-rule="evenodd" d="M7.49352 8.39248C7.32798 8.39248 7.19379 8.25829 7.19379 8.09275V0.299731C7.19379 0.134194 7.32798 -3.8573e-07 7.49352 0C7.65906 3.8573e-07 7.79325 0.134195 7.79325 0.299732V8.09275C7.79325 8.25829 7.65906 8.39248 7.49352 8.39248Z" fill="#FF4402"/>
        <path fill-rule="evenodd" clip-rule="evenodd" d="M9.89073 8.39248C9.7252 8.39248 9.591 8.25828 9.591 8.09274V0.299731C9.591 0.134194 9.7252 -3.53628e-07 9.89074 0C10.0563 3.53628e-07 10.1905 0.134195 10.1905 0.299732V8.09275C10.1905 8.25828 10.0563 8.39248 9.89073 8.39248Z" fill="#FF4402"/>
        <path fill-rule="evenodd" clip-rule="evenodd" d="M12.289 8.39248C12.1235 8.39248 11.9893 8.25829 11.9893 8.09275V0.299731C11.9893 0.134194 12.1235 0 12.289 0C12.4545 0 12.5887 0.134195 12.5887 0.299732V8.09275C12.5887 8.25829 12.4545 8.39248 12.289 8.39248Z" fill="#FF4402"/>
        <path fill-rule="evenodd" clip-rule="evenodd" d="M14.6872 8.39248C14.5217 8.39248 14.3875 8.25828 14.3875 8.09275V0.299731C14.3875 0.134194 14.5217 0 14.6872 0C14.8528 0 14.987 0.134195 14.987 0.299732V8.09275C14.987 8.25828 14.8528 8.39248 14.6872 8.39248Z" fill="#FF4402"/>
        <path fill-rule="evenodd" clip-rule="evenodd" d="M17.0844 8.39248C16.9189 8.39248 16.7847 8.25828 16.7847 8.09275V0.299731C16.7847 0.134194 16.9189 0 17.0844 0C17.2499 0 17.3841 0.134195 17.3841 0.299732V8.09275C17.3841 8.25829 17.2499 8.39248 17.0844 8.39248Z" fill="#FF4402"/>
        <path fill-rule="evenodd" clip-rule="evenodd" d="M19.4827 8.39248C19.3172 8.39248 19.183 8.25828 19.183 8.09275V0.299731C19.183 0.134194 19.3172 0 19.4827 0C19.6483 0 19.7824 0.134195 19.7824 0.299732V8.09275C19.7824 8.25828 19.6483 8.39248 19.4827 8.39248Z" fill="#FF4402"/>
        <path fill-rule="evenodd" clip-rule="evenodd" d="M22.0927 5.7838C21.9038 5.97236 21.5812 5.83857 21.5812 5.57167V0.299731C21.5812 0.134194 21.7154 0 21.8809 0C22.0464 0 22.1806 0.134194 22.1806 0.299731V5.57167C22.1806 5.65126 22.149 5.72758 22.0927 5.7838Z" fill="#FF4402"/>
        <path fill-rule="evenodd" clip-rule="evenodd" d="M24.4901 3.38483C24.3013 3.57365 23.9785 3.43992 23.9785 3.17289V0.299731C23.9785 0.134195 24.1126 3.78273e-07 24.2782 0C24.4437 -3.78273e-07 24.5779 0.134194 24.5779 0.299732V3.17289C24.5779 3.25239 24.5463 3.32862 24.4901 3.38483Z" fill="#FF4402"/>
        <path fill-rule="evenodd" clip-rule="evenodd" d="M26.8883 0.986983C26.6995 1.1758 26.3766 1.04207 26.3766 0.775041V0.299731C26.3766 0.134194 26.5108 0 26.6764 0C26.8419 0 26.9761 0.134194 26.9761 0.299732V0.775041C26.9761 0.854535 26.9445 0.930773 26.8883 0.986983Z" fill="#FF4402"/>
      </svg>
    </div>

    <custom-popup-all-device :popup="additional_menu_popup" ref="additional_menu_popup">
      <template v-slot:header_title>
        {{ $t('side_menu.your_profile') }}
      </template>
      <template v-slot:body>
        <div class="additional-menu-items">
          <div v-if="$store.getters.getUserData && $store.getters.getUserData.permissions.includes('manage_users')" class="additional-menu-item" @click="goToPage('settings')">
            {{ $t('side_menu.profile_settings') }}
          </div>

          <div class="additional-menu-item" @click="additional_menu_popup.show = false; sites_popup.show = true">
            {{ $t('side_menu.my_sites') }}
          </div>

          <div v-if="$store.getters.getUserData && $store.getters.getUserData.permissions.includes('manage_users')" class="additional-menu-item" @click="goToPage('settings_users')">
            {{ $t('side_menu.my_users') }}
          </div>

          <div class="additional-menu-item center">
            <svg @click="logout" v-if="show_mobile_menu" width="36" height="32" viewBox="0 0 36 32" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path fill-rule="evenodd" clip-rule="evenodd"
                    d="M16 0H6C2.68629 0 0 2.68629 0 6L0 26C0 29.3137 2.68629 32 6 32H16V0Z" :fill="color_theme_flag
                    ? '#cfd0d1' :
                    '#2C3236'"/>
              <path fill-rule="evenodd" clip-rule="evenodd" d="M21.5 2H20V30H21.5C24.2614 30 26 28.7614 26 26V21.0594C26 20.6452 26.3358 20.3094 26.75 20.3094C27.1642 20.3094 27.5 20.6452 27.5 21.0594V26C27.5 29.3137 24.8137 32 21.5 32H20H18L18 30L18 1V0L20 0H21.5C24.8137 0 27.5 2.68629 27.5 6V10.9406C27.5 11.3548 27.1642 11.6906 26.75 11.6906C26.3358 11.6906 26 11.3548 26 10.9406V6C26 3.23858 24.2614 2 21.5 2Z" :fill="color_theme_flag
                    ? '#cfd0d1' :
                    '#2C3236'"/>
              <path fill-rule="evenodd" clip-rule="evenodd" d="M30 19.0657C30 19.4651 30.4451 19.7033 30.7773 19.4818L35.376 16.416C35.6728 16.2181 35.6728 15.7819 35.376 15.584L30.7773 12.5182C30.4451 12.2967 30 12.5349 30 12.9343V13.1906C30 13.4667 29.7761 13.6906 29.5 13.6906H24.5C24.2239 13.6906 24 13.9145 24 14.1906V17.8094C24 18.0855 24.2239 18.3094 24.5 18.3094H29.5C29.7761 18.3094 30 18.5333 30 18.8094V19.0657Z" :fill="color_theme_flag
                    ? '#cfd0d1' :
                    '#2C3236'"/>
            </svg>
          </div>

        </div>
      </template>
    </custom-popup-all-device>

    <custom-popup-all-device :popup="sites_popup" ref="sites_popup">
      <template v-slot:header_title>
        {{ $t('settings.users.sites') }}
      </template>
      <template v-slot:body>
        <div class="sites-wrapper">
          <div v-for="(site, site_index) in $store.getters.getUserData.sites" :key="site_index" :class="selectedSiteClass(site)" @click="changeSite(site)">
            {{ site.domain }}
          </div>
        </div>
      </template>
    </custom-popup-all-device>

    <custom-popup-all-device :popup="languages_popup" ref="languages_popup">
      <template v-slot:header_title>
        {{ $t('side_menu.app_languages') }}
      </template>
      <template v-slot:body>
        <table class="languages-wrapper">
          <tr v-for="(language, language_index) in languages" :key="language_index" @click="changeLanguage(language)">
            <td>
              <div class="lang-icon-wrapper" v-html="language.icon"></div>
            </td>
            <td>
              {{ $t(language.title) }}
            </td>
            <td>
              <custom-radio :radio="setLanguageActive(language)"></custom-radio>
            </td>
          </tr>
        </table>
      </template>
    </custom-popup-all-device>
  </div>
</template>

<script>
import CustomPopupAllDevice from '@/components/custom_ui_components/CustomPopupAllDevice'
import CustomRadio from '@/components/custom_ui_components/CustomRadio'
import { logout, setCurrentSiteAndTariffToVuex } from '../../utils/index.js'

export default {
  name: 'MobileHeaderMenu',
  components: {
    CustomPopupAllDevice,
    CustomRadio
  },
  data () {
    return {
      color_theme_flag: this.$store.getters.getColorTheme,
      color_theme_name: this.$t('color_switcher.light'),
      show_mobile_menu: false,
      additional_menu_popup: {
        show: false,
        show_logo: false,
      },
      sites_popup: {
        show: false,
        show_logo: false,
        close_button_func: function() {
          this.additional_menu_popup.show = true
        }.bind(this)
      },
      languages_popup: {
        show: false,
        show_logo: false,
      },
      languages: [
        {
          key: 'ru',
          title: 'russian',
          icon: '<svg width="30" height="30" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M16 2.66666H0V13.3334H16V2.66666Z" fill="#0052B4"/><path d="M16 2.66666H0V6.22213H16V2.66666Z" fill="#F0F0F0"/><path d="M16 9.77756H0V13.333H16V9.77756Z" fill="#D80027"/></svg>'
        },
        {
          key: 'en',
          title: 'english',
          icon: '<svg width="30" height="30" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M15.7241 13.2414H0.275874C0.123531 13.2414 0 13.1179 0 12.9655V3.03454C0 2.8822 0.123531 2.75867 0.275874 2.75867H15.7241C15.8764 2.75867 16 2.8822 16 3.03454V12.9655C15.9999 13.1179 15.8764 13.2414 15.7241 13.2414Z" fill="#41479B"/><path d="M15.9999 3.03454C15.9999 2.8822 15.8764 2.75867 15.7241 2.75867H14.4898L9.37924 6.107V2.75867H6.62063V6.107L1.51006 2.75867H0.275874C0.123531 2.75867 0 2.8822 0 3.03454V3.74801L4.38464 6.62071H0V9.37933H4.38464L0 12.2521V12.9655C0 13.1179 0.123531 13.2414 0.275874 13.2414H1.51009L6.62069 9.89308V13.2414H9.37931V9.89308L14.4899 13.2414H15.7241C15.8765 13.2414 16 13.1179 16 12.9655V12.2521L11.6154 9.37936H15.9999V6.62075H11.6153L15.9999 3.74801V3.03454Z" fill="#F5F5F5"/><path d="M15.9999 7.17246H8.82756V2.75867H7.17238V7.17246H0V8.82761H7.17238V13.2414H8.82756V8.82761H15.9999V7.17246Z" fill="#FF4B55"/><path d="M5.5921 9.37927L0.0078125 13.0042C0.0273437 13.1374 0.137187 13.2413 0.275843 13.2413H0.65581L6.60547 9.3793H5.5921V9.37927Z" fill="#FF4B55"/><path d="M10.8247 9.37927H9.81128L15.7523 13.2356C15.8908 13.2209 16.0001 13.1078 16.0001 12.9654V12.7386L10.8247 9.37927Z" fill="#FF4B55"/><path d="M0 3.33902L5.05557 6.62069H6.06894L0.160718 2.78552C0.0663435 2.82937 0 2.92358 0 3.03449V3.33902Z" fill="#FF4B55"/><path d="M10.3926 6.62071L15.9903 2.98707C15.9671 2.85826 15.8596 2.75867 15.7241 2.75867H15.3288L9.37927 6.62071H10.3926Z" fill="#FF4B55"/></svg>'
        },
        // {
        //   key: 'de',
        //   title: 'deutsch',
        //   icon: '<svg width="24" height="16" viewBox="0 0 24 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M24 5.3796H0V0.551995C0 0.32348 0.185297 0.138184 0.413812 0.138184H23.5862C23.8147 0.138184 24 0.32348 24 0.551995L24 5.3796Z" fill="#464655"/><path d="M23.5861 15.862H0.413812C0.185297 15.862 0 15.6767 0 15.4482V10.6206H24V15.4482C24 15.6767 23.8147 15.862 23.5861 15.862Z" fill="#FFE15A"/><path d="M24 5.37939H0V10.6205H24V5.37939Z" fill="#FF4B55"/></svg>'
        // },
      ],
    }
  },
  created () {
    this.changeColorTheme()
  },
  watch: {
    color_theme_flag () {
      localStorage.setItem('lh-cp-color-theme', this.color_theme_flag)
      this.changeColorTheme()
    }
  },
  methods: {
    setLanguageActive (language) {
      return {
        show: true,
        active: language.key === this.$store.getters.getLanguage ? true : false
      }
    },
    changeLanguage (language) {
      this.$i18n.locale = language.key
      localStorage.setItem('lh-cp-language', language.key)
      this.$store.commit('toggleLanguage', language.key)
    },
    selectedSiteClass (site) {
      if(site.id === this.$store.getters.getSiteId) {
        return 'site-item active-site'
      }
      else {
        return 'site-item'
      }
    },
    changeSite (site) {
      if(site.id === this.$store.getters.getSiteId) return
      localStorage.setItem('lh-cp-site-id', site.id)
      this.$store.commit('setSiteId', site.id)

      if(this.$raven && this.$raven.setExtraContext) {
        this.$raven.setExtraContext()
        this.$raven.setExtraContext({site_id: site.id})
        this.$raven.setExtraContext({site_domain: this.$store.getters.getSiteNameById(site.id)})
      }

      setCurrentSiteAndTariffToVuex.call(this)

      if(this.$router.currentRoute.meta && this.$router.currentRoute.meta.menu &&
        Array.isArray(this.$router.currentRoute.meta.menu)) {

        if(this.$router.currentRoute.meta.menu.includes('Desktop')) {
          this.$router.push({ name: 'Desktop' })
        }
        else if(this.$router.currentRoute.meta.menu.includes('settings')) {
          this.$router.push({ name: 'settings' })
        }
        else if(this.$router.currentRoute.meta.menu.includes('leads')) {
          this.$router.push({ name: 'leads' })
        }
        else if(this.$router.currentRoute.meta.menu.includes('reports')) {
          this.$router.push({ name: 'reports' })
        }
        else if(this.$router.currentRoute.meta.menu.includes('analytics')) {
          this.$router.push({ name: 'analytics' })
        }
        else if(this.$router.currentRoute.meta.menu.includes('integration')) {
          this.$router.push({ name: 'integration' })
        }
        else if(this.$router.currentRoute.meta.menu.includes('library')) {
          this.$router.push({ name: 'library' })
        }
        else if(this.$router.currentRoute.meta.menu.includes('instruments')) {
          this.$router.push({ name: 'instruments' })
        }
        else if(this.$router.currentRoute.meta.menu.includes('settings')) {
          this.$router.push({ name: 'settings' })
        }
        else if(this.$router.currentRoute.meta.menu.includes('settings')) {
          this.$router.push({ name: 'settings' })
        }
      }
      else {
        this.$router.go()
      }
    },
    closeMenu () {
      this.show_mobile_menu = false
    },
    openMenu () {
      this.show_mobile_menu = true
    },
    changeColorTheme () {
      this.color_theme_name = this.color_theme_flag ? this.$t('color_switcher.dark') : this.$t('color_switcher.light')
      this.$store.commit('toggleColorTheme', this.color_theme_flag)
    },
    currentPageMenuClass (page_name) {
      if(this.$router.currentRoute.meta.menu.includes(page_name)) {
        return 'menu-item-wrapper current-mobile-page'
      }
      else {
        return 'menu-item-wrapper'
      }
    },
    goToPage (page_name) {
      this.show_mobile_menu = false
      this.sites_popup.show = false
      this.additional_menu_popup.show = false

      if(this.$router.currentRoute.name !== page_name) {
        this.$router.push({name: page_name})
      }
    },
    logout () {
      logout()
    },
  }
}
</script>

<style lang="scss">

.mobile-header-menu-wrapper {
  width: 100%;
  position: relative;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  flex-direction: column;
  justify-content: space-between;

  &.menu-opened {
    position: fixed;
    overflow-y: auto;
    z-index: 1000;
    background: #ffffff;

    &::-webkit-scrollbar {
      width: 0;
    }
  }


  .mobile-header-wrapper {
    min-height: 60px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    position: relative;

    &.menu-opened {
      padding: 0 15px;
    }

    .grey-switcher.custom-control.custom-switch {
      font-size: 16px;
    }
  }

  .mobile-menu-wrapper {
    .mobile-menu-icons {
      height: 100%;
      margin: 0 20px;

      .profile-data-wrapper {
        margin: 0 auto;
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;
        margin-bottom: 60px;

        .profile-img-wrapper {
          border-bottom: 1px solid #2C3236;
          width: 100%;
          max-width: 200px;
          padding-bottom: 20px;
          margin-bottom: 20px;
        }

        .menu-text-item {
          font-size: 18px;
        }

        .profile-img-circle {
          background: transparent;
          width: 100px;
          display: flex;
          height: 100px;
          align-items: center;
          border-radius: 50px;
          justify-content: center;
          border: 2px solid #FF4402;
          margin: 0 auto;

          img {
            width: 100%;
            border-radius: 50px;
          }
        }
        .select-profile-data-wrapper {
          display: flex;
          align-items: center;
          justify-content: center;

          .select-profile-data-icon {
            margin-left: 10px;
          }
        }
      }
      .menu-items-wrapper {
        display: flex;
        flex-wrap: wrap;
        justify-content: center;
        margin: 0;

        .menu-item-wrapper {
          width: 100px;
          display: flex;
          flex-direction: column;
          align-items: center;
          margin: 5px;

          .icon-wrapper {
            background: #FAFAFA;
            border: 1px solid #CFD0D1;
            border-radius: 3px;
            height: 80px;
            width: 80px;
            display: flex;
            align-items: center;
            justify-content: center;
            margin-bottom: 10px;
          }
          .menu-item-title {
            text-align: center;
          }
        }
        .menu-item-wrapper:nth-last-child(2) {
          margin-bottom: 10%;
        }
        .current-mobile-page {
          .icon-wrapper {
            border: 1px solid #FF4402;
          }
          .menu-item-title {
            color: #FF4402;
          }
          .svg-stroke-hover {
            stroke: #FF4402;
          }
          .svg-fill-hover {
            fill: #FF4402;
          }
        }
      }
    }

    .language {
      width: 40px;
      height: 40px;
      display: flex;
      align-items: center;
      justify-content: center;
      background: #FAFAFA;
      border: 1px solid #CFD0D1;
      border-radius: 3px;
    }
    .language-wrapper {
      width: 100px;
      margin: 0 auto 10% auto;
      display: flex;
      justify-content: center;
    }
  }

  .mobile-menu-footer {
    display: flex;
    align-items: center;
    justify-content: center;
    min-height: 60px;
  }
  .list-footer {
    border-top: 1px solid #CFD0D1;
  }
  .icons-footer {
    border-top: 1px solid #FF4402;
  }

  .mobile-page-wrapper {
    height: calc(100% - 8.5%);
    padding: 0 15px;
  }

  .additional-menu-items {
    padding: 0 15px;
    width: 100%;

    .additional-menu-item {
      padding: 20px 0;
      font-size: 16px;

      &.center {
        display: flex;
        justify-content: center;
      }

      a {
        color: #212529;
      }
    }
    .additional-menu-item:not(:last-child) {
      border-bottom: 1px solid #CFD0D1;
    }
  }
  .sites-wrapper {
    padding: 10px 15px 0 15px;
    overflow-y: auto;
    max-height: 300px;
    width: 100%;

    .site-item {
      width: 250px;
      min-height: 40px;
      border: 1px solid #CFD0D1;
      border-radius: 3px;
      font-size: 16px;
      display: flex;
      align-items: center;
      justify-content: center;
      margin: 0 auto;
      margin-bottom: 10px;
      cursor: pointer;
    }
    .site-item.active-site {
      border: 1px solid #FF4402;
    }
  }
  .languages-wrapper {
    margin: 5px 15px 10px;
    width: calc(100% - 30px);

    td {
      padding: 15px 0;

      .custom-radio-wrapper {
        display: flex;
        justify-content: center;

        .custom-radio {
          width: 24px;
          height: 24px;
          border-radius: 20px;
        }
        .custom-radio.active {
          border: 7px solid #FF4402;
        }
      }
    }
    tr {
      td:nth-child(2) {
        width: 180px;
      }
    }
    tr:last-child td {
      border-top: 1px solid #CFD0D1;
    }
    .lang-icon-wrapper {
      svg {
        width: 30px;
        height: 30px;
      }
    }
  }
  .custom-popup {
    position: absolute;
  }
}

.color-theme-dark {

  .mobile-header-menu-wrapper {
    background: #3F4448;
    color: #CFD0D1;

    .mobile-menu-icons {


      .profile-data-wrapper {

        .profile-img-wrapper {
          border-bottom: 1px solid #CFD0D1;
        }
      }
      .select-profile-data-wrapper {
        svg {
          path {
            fill: #CFD0D1;
          }
        }
      }
      .icon-wrapper {
        background: #2C3236 !important;
      }
      .menu-item-wrapper:not(.current-mobile-page) {
        .icon-wrapper {
          border: 1px solid #5F6467;

          svg {
            .svg-stroke-hover {
              stroke: #CFD0D1;
            }
            .svg-fill-hover {
              fill: #CFD0D1;
            }
            .black-theme-stroke-dark {
              stroke: #2C3236;
            }
          }
        }
      }
    }
    .mobile-menu-icons-wrapper {
      svg {
        path {
          stroke: #CFD0D1;
        }
      }
    }
    .mobile-menu-footer.list-footer {
      svg {
        path {
          fill: #CFD0D1;
        }
      }
    }

    .additional-menu-items {

      .additional-menu-item {

        a {
          color: #CFD0D1;
        }
      }
      .additional-menu-item:not(:last-child) {
        border-bottom: 1px solid #5F6467;
      }
    }

    .mobile-menu-wrapper {

      .language {
        background: #2C3236;
        border: 1px solid #5F6467;
      }
    }
  }
  .mobile-header-menu-wrapper.mobile-list-menu {
    background: #2C3236;

    .current-mobile-page {
      background: #2C3236 !important;
      box-shadow: 4px 4px 10px rgba(0, 0, 0, 0.25) !important;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/main/MobileHeaderMenu.vue